import { StyledPrismicRichText } from "@/components/StyledPrismicRichText";

export default function Feature4Tile({ data, index, rightAlign }) {
  return (
    <div
      style={{
        backgroundColor:
          index === 0
            ? "#47414F"
            : index === 1
              ? "#EEB978"
              : index === 2
                ? "#EFEFEF"
                : "#ffffff",
        color: index === 0 ? "#FFFFFF" : index >= 1 ? "#232629" : "#ffffff",
      }}
      className={`2xl:flex ${index === 0 ? "justify-end" : ""}`}
    >
      <div className="lg:max-w-[480px] sm:flex flex-nowrap gap-[20px] py-[28px] px-[20px] sm:p-[40px]">
        <div
          className={`hidden sm:block min-w-[35px] h-[15px] border-b-[2px]`}
          style={{
            borderBottomColor:
              index === 0 ? "#C5C5C5" : index >= 1 ? "#1F2223" : "#ffffff",
          }}
        ></div>
        <div>
          <div className="title-medium mb-[7px] lg:mb-[16px]">
            <StyledPrismicRichText field={data?.title} />
          </div>
          <div className="text-base">
            <StyledPrismicRichText field={data?.text} />
          </div>
        </div>
      </div>
    </div>
  );
}
